const LanguageCode = "mr";
document.body.classList.add(LanguageCode + "-body");
const Globals = {
  LanguageCode : "mr",
  language_based_api:"https://ws-n.webdunia.com/json/page?lang=" + LanguageCode + "&url=/",
  Desktop_language_based_api:"https://api-en.webdunia.com/api/v3/get-menu-by-id?lang=mr&menuType=NavigationMenu&menuId=1",
  Desktop_header_based_api: "https://api-en.webdunia.com/api/v3/get-menu-by-id?lang=mr&menuType=NavigationMenu&menuId=1",
  Desktop_footer_based_api:"https://api-en.webdunia.com/api/v3/get-menu-by-id?lang=mr&menuType=FooterMenu&menuId=2",
};
export default Globals;
